module.exports = __webpack_public_path__ + "assets/img/bg2.59af49d9.png";